import React, { useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

import "./HeroSection.css";
import { Model } from "../../Model/Model";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [metalType, setMetalType] = useState("gold");

  const changeMetalType = (type) => {
    setMetalType(type);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Map metal types to their display colors for the buttons
  const metalColors = {
    gold: "#ffd700",
    silver: "#C0C0C0",
    roseGold: "#B76E79"
  };

  return (
    <>
      <div className="heroMain">
        <div className="sectionleft">
          <p>New Collection</p>
          <h1>Luxury Jewelry Collection</h1>
          <span>Limited Edition Designs - Free Shipping on Orders Over $100</span>
          <div className="heroLink">
            <Link to="/shop" onClick={scrollToTop}>
              <h5>Explore Collection</h5>
            </Link>
          </div>
        </div>
        <div className="sectionright">
          <Canvas
            className="canvasModel"
            camera={{ position: [0, 5, 15], fov: 50 }}
          >
            <ambientLight intensity={0.5} />
            <directionalLight
              position={[10, 10, 5]}
              intensity={2.5}
              color={"white"}
            />

            <OrbitControls
              enableZoom={false}
              enablePan={false}
              minAzimuthAngle={-Infinity}
              maxAzimuthAngle={Infinity}
              maxPolarAngle={Math.PI / 2}
              minPolarAngle={Math.PI / 2}
            />
            <Model metalType={metalType} />
          </Canvas>
          <div className="heroColorBtn">
            <button
              onClick={() => changeMetalType("gold")}
              style={{ backgroundColor: metalColors.gold }}
              title="Gold"
            ></button>
            <button
              onClick={() => changeMetalType("silver")}
              style={{ backgroundColor: metalColors.silver }}
              title="Silver"
            ></button>
            <button
              onClick={() => changeMetalType("roseGold")}
              style={{ backgroundColor: metalColors.roseGold }}
              title="Rose Gold"
            ></button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
